import React from "react";
import loadingIcon from "../../assets/images/loading.gif";

const SmuButton = ({ control, children, _className, loading }) => {
  return (
    <button
      type="button"
      className={`smu-button-table ${_className || ""}`}
      onClick={control}
    >
      {!loading ? (
        children
      ) : (
        <img src={loadingIcon} alt="Cargando" width={18} />
      )}
    </button>
  );
};

export default SmuButton;
